import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./HowItWorksPage.css";
import Logo from "../img/logo.png";
import bgImage from "../img/blog_background.png";

import berlin from '../img/company/berlin.png'
import esf from '../img/company/esf.jpg'
import hwr from '../img/company/hwr.png'
import sib from '../img/company/sib.jpg'

import { useNavigate, useLocation } from "react-router-dom";

function HowItWorksPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
      }, 100); // small delay for page to render
    } else {
      document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Helmet>
        <title>How It Works - Revexia</title>
        <meta
          name="description"
          content="Learn how Revexia helps businesses understand who is ready to buy inside their social media conversations."
        />
      </Helmet>

      <div className="how-it-works-page">
        {/* Navigation */}
        <nav className="navbar-custom">
          <div className="navbar-container">
            {/* Logo Section */}
            <div className="navbar-brand-custom">
              <Link to="/">
                <img src={Logo} alt="Revexia Logo" className="navbar-logo-img" />
              </Link>
            </div>

            {/* Center Navigation Pills */}
            <div className="navbar-center-pill">
              <ul className="nav-menu-pills">
                <li className="nav-item-pill">
                  <Link to="/" className="nav-link-pill">
                    Home
                  </Link>
                </li>
                <li className="nav-item-pill">
                  <a href="/#features" className="nav-link-pill" onClick={handleClick}>
                    Feature
                  </a>
                </li>

                <li className="nav-item-pill nav-item-dropdown">
                  <button className="nav-link-pill nav-dropdown-toggle">
                    Resources
                    <svg
                      width="10"
                      height="6"
                      viewBox="0 0 10 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="dropdown-arrow"
                    >
                      <path
                        d="M1 1L5 5L9 1"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <div className="nav-dropdown-menu">
                    <Link to="/how" className="nav-dropdown-item">
                      How it works
                    </Link>
                    <Link to="/support" className="nav-dropdown-item">
                      Support overview
                    </Link>
                    <Link to="/trust" className="nav-dropdown-item">
                      Trust Center
                    </Link>
                    <Link to="/privacy-policy" className="nav-dropdown-item">
                      Privacy Policy
                    </Link>
                    <Link to="/terms" className="nav-dropdown-item">
                      Terms of Service
                    </Link>
                     <Link to="/facebook-terms" className="nav-dropdown-item">
                                          Facebook Terms
                                        </Link>
                  </div>
                </li>
                <li className="nav-item-pill">
                  <Link to="/blog" className="nav-link-pill">
                    Blog
                  </Link>
                </li>
                
              </ul>
            </div>

            {/* Right Side - Auth Buttons */}
            <div className="navbar-auth-section">
              {user ? (
                <>
                  <Link to="/dashboard" className="btn-nav-outline">
                    Dashboard
                  </Link>
                  <button onClick={handleLogout} className="btn-nav-gradient">
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/auth" className="btn-nav-gradient">
                    Get Started
                  </Link>
                    <Link to="/auth" className="btn-nav-gradientlogin">
                    Login
                  </Link>
                </>
              )}
            </div>

            {/* Mobile Toggle */}
            <button
              className="navbar-mobile-toggle"
              type="button"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <span className="navbar-toggler-icon-custom"></span>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="navbar-mobile-menu">
              <ul className="mobile-nav-list">
                <li>
                  <Link to="/" onClick={() => setMobileMenuOpen(false)}>
                    Home
                  </Link>
                </li>

                <li >
                  <a href="/#features" onClick={(e) => {
                      setMobileMenuOpen(false);
                      handleClick(e);
                    }} >
                    Feature
                  </a>
                </li>
                
                <li>
                  <Link to="/how" onClick={() => setMobileMenuOpen(false)}>
                    How it works
                  </Link>
                </li>
                <li>
                  <Link to="/support" onClick={() => setMobileMenuOpen(false)}>
                    Support overview
                  </Link>
                </li>
                <li>
                  <Link to="/trust" onClick={() => setMobileMenuOpen(false)}>
                    Trust Center
                  </Link>
                </li>
                <li>
                  <Link to="/blog" onClick={() => setMobileMenuOpen(false)}>
                    Blog
                  </Link>
                </li>
                
              </ul>
              <div className="mobile-auth-buttons">
                {user ? (
                  <>
                    <Link
                      to="/dashboard"
                      className="btn-nav-outline"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Dashboard
                    </Link>
                    <button
                      onClick={() => {
                        handleLogout();
                        setMobileMenuOpen(false);
                      }}
                      className="btn-nav-gradient"
                    >
                      Logout
                    </button>
                  </>
                ) : (
                  <>
                    <Link
                      to="/auth"
                      className="btn-nav-gradient"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Login
                    </Link>
                  </>
                )}
              </div>
            </div>
          )}
        </nav>

        {/* Main Content */}
        <main className="how-it-works-main">
          {/* Hero Section with Background */}
          <section className="hiw-hero-section">
            {/* Background Effects */}
            <div className="hiw-hero-bg-effects">
              <div className="hiw-hero-bg-image-wrapper">
                <img
                  src={bgImage}
                  alt=""
                  className="hiw-hero-bg-image"
                />
              </div>
              <div className="hiw-hero-gradient-overlay"></div>
            </div>

            {/* Hero Content */}
            <div className="hiw-hero-content">
              <div className="hiw-hero-badge">HOW IT WORKS</div>
             
              <p className="hiw-hero-subtitle">
                From first message to paid order: Revexia finds your buyers, closes the sale with AI, and shows the revenue from every conversation.
              </p>
            </div>
          </section>

          {/* Visual Flow Section */}
          <section className="hiw-flow-section">
            <div className="hiw-flow-container">
              <div className="hiw-flow-header">
                <h2 className="hiw-section-title">
                  How Revexia Turns Conversations Into Revenue
                </h2>
                <p className="hiw-section-subtitle">
                  From message → buyer intent → safe, revenue-focused actions
                </p>
              </div>

              <div className="hiw-flow-steps">
                {/* Step 1 */}
                <div className="hiw-step">
                  <div className="hiw-step-card">
                    <div className="hiw-step-icon">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M15.75 2.25H2.25C1.42157 2.25 0.75 2.92157 0.75 3.75V14.25C0.75 15.0784 1.42157 15.75 2.25 15.75H15.75C16.5784 15.75 17.25 15.0784 17.25 14.25V3.75C17.25 2.92157 16.5784 2.25 15.75 2.25Z"
                          stroke="white"
                          strokeWidth="1.5"
                        />
                      </svg>
                    </div>
                    <h3 className="hiw-step-title">Customer conversation</h3>
                    <ul className="hiw-step-list">
                      <li>Instagram, Facebook & TikTok</li>
                      <li>WhatsApp</li>
                      <li>Emails</li>
                    </ul>
                  </div>
                  <p className="hiw-step-description">
                    Where conversations start
                  </p>
                </div>

                <div className="hiw-arrow">→</div>

                {/* Step 2 */}
                <div className="hiw-step">
                  <div
                    className="hiw-step-card"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <div className="hiw-step-icon">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M2.25 6.75H15.75M2.25 11.25H15.75M15.75 2.25H2.25C1.42157 2.25 0.75 2.92157 0.75 3.75V14.25C0.75 15.0784 1.42157 15.75 2.25 15.75H15.75C16.5784 15.75 17.25 15.0784 17.25 14.25V3.75C17.25 2.92157 16.5784 2.25 15.75 2.25Z"
                          stroke="white"
                          strokeWidth="1.5"
                        />
                      </svg>
                    </div>
                    <h3
                      className="hiw-step-title"
                      style={{
                        textAlign: 'center',
                        width: '100%',
                        margin: 0
                      }}
                    >
                      Universal agentic inbox
                    </h3>

                    <div style={{ display: 'none' }}>
                      <ul className="hiw-step-list">
                        <li>ManyChat</li>
                        <li>Respond.io</li>
                        <li>Compatible Platforms</li>
                      </ul>
                    </div> 
                  </div>
                  <p className="hiw-step-description" style={{ display: 'none' }}>
                    Where conversations are collected
                  </p>
                </div>

                <div className="hiw-arrow">→</div>

                {/* Step 3 - Intelligence Layer */}
                <div className="hiw-step hiw-step-highlight">
                  <p className="hiw-step-label">INTELLIGENCE LAYER</p>
                  <div className="hiw-step-card-highlight">
                    <div className="hiw-step-icon-highlight">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M9 15.75L2.625 9.375L4.5 7.5L9 12L13.5 7.5L15.375 9.375L9 15.75Z"
                          stroke="white"
                          strokeWidth="1.5"
                        />
                      </svg>
                    </div>
                    <h3 className="hiw-step-title-highlight">Revexia AI</h3>
                    <ul className="hiw-step-list-highlight">
                      <li>
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            d="M2.625 7L5.25 9.625L11.375 3.5"
                            stroke="#38BDF8"
                            strokeWidth="1.17"
                          />
                        </svg>
                        Reads conversations
                      </li>
                      <li>
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            d="M2.625 7L5.25 9.625L11.375 3.5"
                            stroke="#38BDF8"
                            strokeWidth="1.17"
                          />
                        </svg>
                        Understand customer intent across selling platforms
                      </li>
                      <li>
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            d="M2.625 7L5.25 9.625L11.375 3.5"
                            stroke="#38BDF8"
                            strokeWidth="1.17"
                          />
                        </svg>
                        Identifies buyers
                      </li>
                      <li>
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            d="M2.625 7L5.25 9.625L11.375 3.5"
                            stroke="#38BDF8"
                            strokeWidth="1.17"
                          />
                        </svg>
                        Recommends actions
                      </li>
                    </ul>
                  </div>
                  <p className="hiw-step-description-highlight">
                    Analyzes & Identifies
                  </p>
                </div>

                <div className="hiw-arrow">→</div>

                {/* Step 4 */}
                <div className="hiw-step">
                  <div className="hiw-step-outputs">
                    <div className="hiw-output-card">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M14 2H10L8 4H2C1.46957 4 0.960859 4.21071 0.585786 4.58579C0.210714 4.96086 0 5.46957 0 6V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H14C14.5304 16 15.0391 15.7893 15.4142 15.4142C15.7893 15.0391 16 14.5304 16 14V4C16 3.46957 15.7893 2.96086 15.4142 2.58579C15.0391 2.21071 14.5304 2 14 2Z"
                          stroke="#38BDF8"
                          strokeWidth="1.33"
                        />
                      </svg>
                      <div>
                        <h4 className="hiw-output-title">
                          Buyer Priority List
                        </h4>
                        <p className="hiw-output-desc">Know who is ready</p>
                      </div>
                    </div>

                    <div className="hiw-output-card">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346632 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87897 15.1541 3.84547 13.6543 2.34568C12.1545 0.845885 10.121 0.00229405 8 0Z"
                          stroke="#38BDF8"
                          strokeWidth="1.33"
                        />
                      </svg>
                      <div>
                        <h4 className="hiw-output-title">
                          Intent-Based Offers
                        </h4>
                        <p className="hiw-output-desc">Right offer, right time</p>
                      </div>
                    </div>

                    <div className="hiw-output-card">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M8 2V14M2 8H14"
                          stroke="#38BDF8"
                          strokeWidth="1.33"
                        />
                      </svg>
                      <div>
                        <h4 className="hiw-output-title">Safe Follow-ups</h4>
                        <p className="hiw-output-desc">No spam behavior</p>
                      </div>
                    </div>
                  </div>
                  <p className="hiw-step-description">Tangible Outputs</p>
                </div>
              </div>
            </div>
          </section>

          {/* Demo Video Section */}
          <section className="hiw-demo-section" style={{ display: 'none' }}>
            <div className="hiw-demo-container">
              <h2 className="hiw-demo-title">See Revexia in Action</h2>
              <p className="hiw-demo-subtitle">
                Watch how intent-based automation transforms your DM strategy.
              </p>
              <div className="hiw-video-placeholder">
                <div className="hiw-video-overlay"></div>
                <button className="hiw-play-button" aria-label="Play video">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      d="M10 6.66667L24 16L10 25.3333V6.66667Z"
                      fill="white"
                      stroke="white"
                      strokeWidth="2.67"
                    />
                  </svg>
                </button>
                <div className="hiw-video-label">
                  <span>Live Demo: Intent Detection in Action</span>
                </div>
              </div>
            </div>
          </section>

          {/* Who Revexia Is For Section */}
          <section className="hiw-for-section">
            <div className="hiw-for-container">
              <div className="hiw-for-header">
                <h2 className="hiw-section-title">Who Revexia Is For</h2>
                <p className="hiw-section-subtitle">
                  Built for high-volume conversational commerce
                </p>
              </div>

              <div className="hiw-for-grid">
                <div className="hiw-for-card">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M3 9H21M3 15H21M9 3H15C16.1046 3 17 3.89543 17 5V19C17 20.1046 16.1046 21 15 21H9C7.89543 21 7 20.1046 7 19V5C7 3.89543 7.89543 3 9 3Z"
                      stroke="#4B6CFF"
                      strokeWidth="2"
                    />
                  </svg>
                  <div>
                    <h3 className="hiw-for-card-title">
                      Brands Selling via DMs
                    </h3>
                    <p className="hiw-for-card-desc">
                      Direct-to-consumer brands that use social engagement as a
                      primary sales channel.
                    </p>
                  </div>
                </div>

                <div className="hiw-for-card">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M17 20H22V18C22 16.3431 20.6569 15 19 15C18.0444 15 17.1931 15.4468 16.6438 16.1429M17 20H7M17 20V18C17 17.3438 16.8736 16.717 16.6438 16.1429M7 20H2V18C2 16.3431 3.34315 15 5 15C5.95561 15 6.80686 15.4468 7.35625 16.1429M7 20V18C7 17.3438 7.12642 16.717 7.35625 16.1429M7.35625 16.1429C8.0935 14.301 9.89482 13 12 13C14.1052 13 15.9065 14.301 16.6438 16.1429M15 7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7ZM21 10C21 11.1046 20.1046 12 19 12C17.8954 12 17 11.1046 17 10C17 8.89543 17.8954 8 19 8C20.1046 8 21 8.89543 21 10ZM7 10C7 11.1046 6.10457 12 5 12C3.89543 12 3 11.1046 3 10C3 8.89543 3.89543 8 5 8C6.10457 8 7 8.89543 7 10Z"
                      stroke="#4B6CFF"
                      strokeWidth="2"
                    />
                  </svg>
                  <div>
                    <h3 className="hiw-for-card-title">Support Teams</h3>
                    <p className="hiw-for-card-desc">
                      Teams struggling to filter high-value buyers from general
                      support queries in inbox chaos.
                    </p>
                  </div>
                </div>

                <div className="hiw-for-card">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M9 12H15M9 16H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z"
                      stroke="#4B6CFF"
                      strokeWidth="2"
                    />
                  </svg>
                  <div>
                    <h3 className="hiw-for-card-title">Digital Creators</h3>
                    <p className="hiw-for-card-desc">
                      Creators selling courses, templates, or physical merch
                      through story replies.
                    </p>
                  </div>
                </div>

                <div className="hiw-for-card">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M7 10L12 7L17 10M7 10L12 13M7 10V14L12 17M17 10L12 13M17 10V14L12 17M12 13V17"
                      stroke="#4B6CFF"
                      strokeWidth="2"
                    />
                  </svg>
                  <div>
                    <h3 className="hiw-for-card-title">Automation Users</h3>
                    <p className="hiw-for-card-desc">
                      Businesses already using ManyChat or Respond.io who want
                      smarter logic.
                    </p>
                  </div>
                </div>

                <div className="hiw-for-card">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M3 3H8L10 8H6L8 13H10L8 21M16 3H21L19 8H15L17 13H19L17 21"
                      stroke="#4B6CFF"
                      strokeWidth="2"
                    />
                  </svg>
                  <div>
                    <h3 className="hiw-for-card-title">
                      E-commerce Sellers
                    </h3>
                    <p className="hiw-for-card-desc">
                      Shopify, WooCommerce, Etsy, and Stan Store sellers scaling
                      efficiently.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="cta-section-final" id="cta">
          <style>{`
            .logo-marquee-wrapper {
              position: relative;
              width: 100%;
              max-width: 100%;
              overflow: hidden;
              margin-top: 48px;
              padding: 16px 0;
            }

            .logo-marquee-track {
              display: flex;
              width: max-content;
              animation: logo-marquee-scroll 30s linear infinite;
              will-change: transform;
            }

            .logo-marquee-group {
              display: flex;
              align-items: center;
              flex-shrink: 0;
            }

            .logo-marquee-item-box {
              width: 160px;
              height: 56px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
            }

            .logo-marquee-item {
              height: 36px;
              width: auto;
              max-width: 140px;
              object-fit: contain;
              opacity: 0.85;
              transition: opacity 0.3s ease;
              display: block;
            }

            .logo-marquee-item:hover {
              opacity: 1;
            }

            @keyframes logo-marquee-scroll {
              from {
                transform: translateX(0);
              }
              to {
                transform: translateX(-25%);
              }
            }
          `}</style>

          <div className="container-cta-final">
            {/* Purple Gradient Blur Background */}
            <div className="cta-gradient-blur"></div>
            {/* CTA Content */}
            <div className="cta-content-wrapper">
              {/* Heading Container */}
              <div className="cta-heading-container">
                <h2 className="cta-main-heading">
                  Start Building Your AI Revenue Brain Today.
                </h2>
              </div>
              {/* Subheading Container */}
           
              {/* CTA Buttons */}
              <div className="cta-buttons-wrapper">
                {/* Primary CTA Button - Get Started */}
                
                  <Link to="/auth" className="contact-btn-primary">
                    <span className="cta-button-text">Get started</span>
                   </Link>
                  
             
                {/* Secondary CTA Button - Watch Demo */}
                <button className="cta-button-secondary" style={{ display: 'none' }}>
                  {/* Gradient Overlay */}
                  <div className="button-gradient-overlay"></div>
                  {/* Horizontal Divider */}
                  <div className="button-horizontal-divider"></div>
                  {/* Animated Dots */}
                  <div className="button-dot-glow dot-1"></div>
                  <div className="button-dot-normal dot-2"></div>
                  <div className="button-dot-small dot-3"></div>
                  {/* Button Content */}
                  <div className="cta-button-content">
                    <svg
                      className="play-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M3.33325 2L12.6666 8L3.33325 14V2Z"
                        fill="white"
                        stroke="white"
                        strokeWidth="1.33"
                      />
                    </svg>
                    <a
  href="https://www.youtube.com/watch?v=G7D5c40whQA"
  target="_blank"
  rel="noopener noreferrer"
  style={{ color: "black" }}
>
  <span className="cta-button-text-secondary">
    What is Revexia
  </span>
</a>
                  </div>
                </button>
              </div>
              {/* Partner Logos Marquee - Scrolling Ticker */}
              <div className="logo-marquee-wrapper">
                <div className="logo-marquee-track">
                  {[0, 1, 2, 3].map((groupIndex) => (
                    <div
                      className="logo-marquee-group"
                      key={groupIndex}
                      aria-hidden={groupIndex !== 0}
                    >
                      <div className="logo-marquee-item-box">
                        <img
                          src={berlin}
                          alt={groupIndex === 0 ? "Berlin" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                      <div className="logo-marquee-item-box">
                        <img
                          src={esf}
                          alt={groupIndex === 0 ? "European Social Fund" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                      <div className="logo-marquee-item-box">
                        <img
                          src={hwr}
                          alt={groupIndex === 0 ? "HWR Berlin" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                      <div className="logo-marquee-item-box">
                        <img
                          src={sib}
                          alt={groupIndex === 0 ? "Startup Incubator Berlin" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        </main>

        {/* Footer */}
        <footer className="footer-v2" id="contact">
          <div className="container-footer-v2">
            <div className="footer-main-content">
              <div className="footer-brand-section-v2">
                <div className="footer-logo-wrapper">
                  <img src={Logo} alt="Revexia" className="footer-logo-image" />
                </div>
                <p className="footer-brand-description-v2">
                  A platform to turn social media DM engagement into automated
                  revenue with AI-driven personalization.
                </p>
              </div>

              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Informations</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                 
                </ul>
              </div>

              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Social</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <a
                      href="https://www.facebook.com/share/1AhWEt4FyM/?mibextid=wwXIfr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/revexia.ai/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Instagram
                    </a>
                  </li>
                  
                  <li>
                    <a
                      href="https://www.linkedin.com/company/revexiaai/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      LinkedIn
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/revexia.ai"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      TikTok
                    </a>
                  </li>
                </ul>
              </div>

              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Help</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                 
                  <li>
                    <Link to="/terms">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                   <li>
                                      <Link to="/facebook-terms">Facebook Terms</Link>
                                    </li>
                </ul>
              </div>
            </div>

            <hr className="footer-divider-line-v2" />

            <div className="footer-bottom-v2">
              <p className="footer-copyright-v2">
                ©2026 Revexia. All rights reserved. Developed by{" "}
                <a
                  href="https://softwarebari.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="developer-link"
                >
                  Softwarebari
                </a>
                .
              </p>
              <div className="footer-legal-links-v2">
                <Link to="/privacy-policy">Privacy Policy</Link>
                <span className="separator-v2">|</span>
                <Link to="/terms">Terms & Conditions</Link>
                <span className="separator-v2">|</span>
                <Link to="/cookies">Cookies Policy</Link>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default HowItWorksPage;
